export const appSettings = {
  auth: {
    domain: process.env.REACT_APP_AUTH0_DOMAIN || 'livinglab-development.us.auth0.com',
    client_id: process.env.REACT_APP_AUTH0_CLIENT_ID || '4GCIJ5CqacRCS5KiUTF3R0beS7mMkCxq',
    redirect_uri: window.location.origin,
    scope: 'openid profile email user_metadata LivingLab',
    audience: process.env.REACT_APP_AUDIENCE || 'https://dataservices',
    claims_namespace: process.env.REACT_APP_CLAIM_NAMESPACE || 'https://development.ovation.io',
  },
  api: {
    endpoint: process.env.REACT_APP_API_URL,
    prince_metrics_dns: process.env.REACT_APP_PRINCE_METRICS_DNS,
  },
  license: {
    muiX: '4fbc1ca3365598c4a9d6d0cc7c71d64cTz0xMDk0MzgsRT0xNzc0MzEwMzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=',
  },
  depthStore: {
    endpoint: process.env.REACT_APP_DEPTHSTORE_API_URL,
  },
};

export type ApiVersion = 'v1' | 'v2' | 'v3';
export const API_VERSION = {
  v1: 'v1' as ApiVersion,
  v2: 'v2' as ApiVersion,
  v3: 'v3' as ApiVersion,
} as const;
